// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__29COb","loaderOuter":"PageOverlayLoader_loaderOuter__3hRFz"};